export default __webpack_public_path__ + "d328b1e2d70634a7c9e620fb0bb7d6f3.svg";